import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=2fc4bb7c&scoped=true&lang=html&"
import script from "./Exam.vue?vue&type=script&lang=ts&"
export * from "./Exam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc4bb7c",
  null
  
)

export default component.exports